import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

// Without this, any uncaught render error (e.g. a field the API stopped
// sending, an unexpected null) unmounts the whole tree and the dashboard
// goes completely blank with nothing in the UI to explain why -- exactly
// what happened when /api/signals returned fields the table renderer
// didn't expect. This shows the error instead so it's diagnosable from
// the screen, not just devtools.
export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('Dashboard render error:', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '40px', maxWidth: '500px', margin: '80px auto', fontFamily: 'sans-serif' }}>
          <h1>Dashboard error</h1>
          <p style={{ color: '#b00020', background: '#fdecea', padding: '12px', borderRadius: '4px' }}>
            {this.state.error.message}
          </p>
          <button onClick={() => this.setState({ error: null })} style={{ padding: '10px 16px' }}>
            Coba lagi
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
